export const tabContent = [
  {
    id: "adCreation",
    label: "Ads Creation",

    services: [
      "Image Generator",
      "Hook Generator",
      "Video Generator",
      "Bulk Maker",
      "Copy Ads Creator",
    ],

    middle: "/assets/homePage/workspace/AD-CREATIVE.json",

    last: {
      title: "Built for creative teams moving fast",
      desc: `
        From AI generation to campaign execution,
        Imagive.ai keeps your entire workflow connected
        — without switching between tools.
      `,
      cta: "Explore Workspace",
      href: "https://app.imagive.ai?redirect=/users/my-gallery",
    },
  },

  {
    id: "distribution",
    label: "Multi-Platform Distributions",

    services: [
      "Meta Integration",
      "Facebook Publishing",
      "Multi-Channel Export",
      "Smart Resize",
      "Platform Presets",
    ],

    middle: "/assets/homePage/workspace/PLATFORM.json",

    last: {
      title: "Publish and scale creatives across every channel",
      desc: `
        Automatically adapt, resize, organize,
        and distribute campaign creatives for every
        platform, placement, and aspect ratio.
      `,
      cta: "Explore Distribution",
      href: "https://app.imagive.ai?redirect=/users/ads-library",
    },
  },

  {
    id: "intelligence",
    label: "Campaign Intelligence",

    services: [
      "Creative Analytics",
      "Competitor Insights",
      "Multi-Channel Export",
      "Smart Resize",
      "Winning Patterns",
    ],

    middle: "/assets/homePage/workspace/CREATIVE-INTEGIGENCE.json",

    last: {
      title: "Understand what actually drives performance",
      desc: `
        Track campaign performance, uncover winning
        creative patterns, detect fatigue early,
        and optimize decisions using AI-powered insights.
      `,
      cta: "Explore Intelligence",
      href: "https://app.imagive.ai?redirect=/users/competitive-analysis",
    },
  },

  {
    id: "brand",
    label: "Brand Management",

    services: [
      "Workspace Collaboration",
      "Brand Kit",
      "Asset Library",
      "Team Permissions",
      "Approvals",
    ],

    middle: "/assets/homePage/workspace/BRAND-MANAGEMENT.json",

    last: {
      title: "Keep your entire brand workflow connected",
      desc: `
        Manage assets, approvals, collaboration,
        and brand consistency from one centralized
        workspace built for creative teams.
      `,
      cta: "Explore Brand setup",
      href: "https://app.imagive.ai?redirect=/users/brands",
    },
  },
];
